module.exports = __webpack_public_path__ + "img/Mask Group1@2x.1a210882.png";